<script setup lang="ts">
import { onMounted, watch } from "vue"
import ApplicationBase from "../ApplicationBase.vue"
import { useAuthStore } from '@/stores/useAuthStore'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

const auth = useAuthStore()
const { umsokn } = useUmsokn()

// Begin + steps
import BeginStep from './Steps/ApplicationTilgreindSereignBegin.vue'
import Step1 from './Steps/Step1.vue'   // ← Umsækjandi (new step you added)
import Step2 from './Steps/Step2.vue'
import Step3 from './Steps/Step3.vue'
import Step4 from './Steps/Step4.vue'
import Step5 from './Steps/Step5.vue'
import Step6 from './Steps/Step6.vue'
import Step7 from './Steps/Step7.vue'
import Undirritun from '../Shared/Undirritun.vue'
import Umsaekjandi from '../Shared/Umsaekjandi.vue' 

const APP_ID = 10
const UPDATE_KEY = 'tilgreind-sereign' // matches your current composable usage

const steps = [
  { comp: BeginStep, titleKey: 'umsokn_tilgreind_sereign_step0_header1' },

  { comp: Umsaekjandi,     titleKey: 'umsokn_umsaekjandi_header' },
  { comp: Step2,     titleKey: 'umsokn_tilgreind_sereign_step2_header_new' },
  { comp: Step3,     titleKey: 'umsokn_tilgreind_sereign_step3_header' },
  { comp: Step4,     titleKey: 'umsokn_tilgreind_sereign_step4_1_header' },
  { comp: Step5,     titleKey: 'umsokn_tilgreind_sereign_step4_header' },
  { comp: Step6,     titleKey: 'radstofun_idgjalds_step5_header' },
  { comp: Step7,     titleKey: 'umsokn_samantekt_header' },
  { comp: Undirritun,   titleKey: 'undirritun_umsokn_header1' },
]


watch(
  () => umsokn.value,
  () => {
    if (!umsokn.value) return

    if (umsokn.value.lykilupplysingarAccepted === null) {
      umsokn.value.lykilupplysingarAccepted = false
    }
  },
  { deep: false }
)
</script>


<template>
  <ApplicationBase :app-id="APP_ID" :update-key="UPDATE_KEY" :steps="steps" />
</template>
